var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 478.138 478.138",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0,208.676 0,269.527 254.535,269.527 240.946,208.676  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,373.002v60.873h409.823v-56.947c-3.991-0.82-7.809-2.243-11.562-3.969L0,373.002L0,373.002z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "242.758,55.264 328.372,105.158 409.823,105.158 409.823,44.263 0,44.263 0,105.158 217.822,105.158  211.804,78.129  "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.268,84.406l-5.242,3.947l58.953,264.005l47.564-80.437l50.476,69.005c9.599,13.029,26.554,16.782,38.029,8.391 c11.389-8.369,13.007-25.648,3.451-38.676l-50.497-69.005l91.137-21.075L244.268,84.406z"
  }))), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("g", null))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelected);
export default __webpack_public_path__ + "static/media/selected.2c415528ef920122169f126a302e8a52.svg";
export { ForwardRef as ReactComponent };